// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1_Ovs","disabled":"FileBtn_disabled__1M77f","warn":"FileBtn_warn__3OnXW","fade":"FileBtn_fade__2Hu65"};